<template>
  <div class="e-nav" v-if="$route.path !== '/m/my'" @click="showNav = false">
    <div class="e-nav-index" v-if="isIndex">
      <div class="nav-left">
        <div class="e-nav-index-icon">
          <img src="../../../../static/images/college_logo.png" alt="">
        </div>
        <h1>睿慕课学院</h1>
      </div>
      <router-link v-if="$store.state.userInfo" to="/m/myclass" class="nav-right">我的教室</router-link>
      <a v-else @click="goLoginHref" class="nav-right">登录</a>
    </div>
    <div class="e-nav-common" v-else>
      <div class="nav-left" @click="handleGoBack">
        <i class="iconfont icon-zuojiantou"></i>
        {{ $route.meta.name_cn }}
      </div>
      <div class="nav-right" @click.stop="showNav = !showNav">
        <i class="iconfont icon-sangedian"></i>
      </div>
    </div>
    <ul class="sliders" :class="showNav ? 'act' : ''" v-if="!isIndex && $store.state.userInfo">
      <li @click="$router.push('/m')">回到首页</li>
      <li @click="$router.push('/m/myclass')">我的教室</li>
      <!-- <li @click="$router.push('/m/query')">证书查询</li> -->
      <li @click="$router.push('/m/my')">个人中心</li>
      <li @click="logout">安全退出</li>
    </ul>
    <ul class="sliders" :class="showNav ? 'act' : ''" v-if="!isIndex && !$store.state.userInfo">
      <li @click="$router.push('/m')">回到首页</li>
      <li @click="goLoginHref">前往登录</li>
    </ul>
  </div>
</template>

<script>
import api from '@/api/index'

export default {
  data () {
    return {
      showNav: false
    }
  },
  computed: {
    isIndex () {
      return this.$route.path === '/m'
    }
  },
  methods: {
    async logout() {
      await api.logout()
      this.delCookie()
      this.$router.push('/m')
      this.$store.commit('upDateUserInfo', {})
    },
    delCookie() {
      let keys = document.cookie.match(/[^ =;]+(?==)/g);
      if(keys) {
        for(var i = keys.length; i--;) {
          document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
        }
      }
    },
    goLoginHref() {
      window.location.href = "https://www.aiimooc.com/mobile/login.php?forward=" + window.location.href
    },
    handleGoBack () {
      // console.log(this.$route.meta)
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.e-nav{
  width: 100%;
  height: 52px;
  box-sizing: border-box;
  position: relative;
  .e-nav-index{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 52px;
    background-color: #fff;
    .nav-left{
      line-height: 52px;
      height: 52px;
      h1{
        display: inline-block;
        vertical-align: top;
        font-weight: 700;
      }
      .e-nav-index-icon{
        background-color: #FE5454;
        width: 32px;
        height: 32px;
        margin-left: 18px;
        border-radius: 50%;
        display: inline-block;
        margin-top: 10px;
        margin-right: 5px;
        img{
          display: block;
          width: 16.3px;
          height: 22.9px;
          margin: 0 auto;
          margin-top: 5.4px;
        }
      }
    }
    .nav-right{
      border: 1px solid #F54747;
      border-radius: 7px;
      text-align: center;
      line-height: 21px;
      box-sizing: border-box;
      width: 65px;
      height: 23px;
      color: #F54747;
      font-size: 12px;
      text-decoration: none;
      margin-right: 18px;
      .iconfont{
        font-size: 20px;
      }
    }
  }
  .e-nav-common{
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 52px;
    line-height: 52px;
    position: relative;
    z-index: 20;
    .nav-left{
      font-size: 14px;
      color: #5C5F63;
      padding-left: 20px;
    }
    .nav-right{
      padding-right: 16px;
      padding-left: 16px;
      color: #CACDD2;
      .iconfont{
        font-size: 20px;
      }
    }
  }
  .sliders{
    position: absolute;
    right: 0;
    bottom: 0;
    padding: 6px;
    width: 100px;
    box-sizing: border-box;
    box-shadow: rgba(0, 0, 0, .01) 0 1px 1px;
    border-radius: 0 0 8px 8px;
    z-index: 10;
    transform: translate3d(0, -100%, 0);
    transition: all .3s;
    background-color: #fff;
    opacity: 0;
    &.act{
      box-shadow: rgba(0, 0, 0, .16) 0 10px 6px;
      transform: translate3d(0, 100%, 0);
      opacity: 1;
    }
    li{
      font-size: 16px;
      line-height: 28px;
      color: #5C5F63;
      text-align: center;
    }
  }
}
</style>
